import { useMemo } from 'react';
import { generatePlaceholderPhotos } from '../utils/custom.utils';
import { Photo } from '../components/PhotoTrio/PhotoTrio.types';

export const useGetFilledPhotos = <T extends Photo>(photos: T[], photoCountToShow: number, fillWithPlaceholderPhotos = true, defaultPhotos: T[] = []) => {
  const filledPhotos = useMemo(() => {
    // if defaultPhoto is provided, then we will use if the photos array is empty
    const photosToShow: T[] = photos.length > 0 ? [...photos.slice(0, photoCountToShow)] : [...defaultPhotos.slice(0, photoCountToShow)];
    // Fill remaining slots with placeholder photos
    if (fillWithPlaceholderPhotos && photosToShow.length < photoCountToShow) {
      photosToShow.push(...(generatePlaceholderPhotos(photoCountToShow - photosToShow.length) as T[]));
    }
    return photosToShow;
  }, [photos, photoCountToShow, defaultPhotos, fillWithPlaceholderPhotos]);

  return { filledPhotos };
};
